import { useMutation } from "@tanstack/react-query";
import { loginAuth } from "../firebase";
import { getFirebaseErrorMessage, isRetryableError, getErrorSeverity } from "../utils/firebaseErrorHandler";

export const useLoginMutation = () => {
  return useMutation({
    mutationFn: async ({ email, password, navigate }) => {
      try {
        return await loginAuth(email, password, navigate);
      } catch (error) {
        // Create enhanced error object
        const enhancedError = new Error(error.message || 'Login failed');
        enhancedError.code = error.code;
        enhancedError.userMessage = getFirebaseErrorMessage(error);
        enhancedError.isRetryable = isRetryableError(error);
        enhancedError.severity = getErrorSeverity(error);
        enhancedError.originalError = error;
        throw enhancedError;
      }
    },
    onError: (error) => {
      console.error("Login error:", {
        code: error.code,
        message: error.message,
        userMessage: error.userMessage,
        isRetryable: error.isRetryable,
        severity: error.severity
      });
    },
    retry: (failureCount, error) => {
      // Only retry for retryable errors, max 2 retries
      if (error.isRetryable && failureCount < 2) {
        return true;
      }
      return false;
    },
    retryDelay: (attemptIndex) => {
      // Exponential backoff: 1s, 2s, 4s
      return Math.min(1000 * Math.pow(2, attemptIndex), 4000);
    }
  });
};
